import { render, staticRenderFns } from "./StatementRemove.vue?vue&type=template&id=f3e408a2&"
import script from "./StatementRemove.vue?vue&type=script&lang=js&"
export * from "./StatementRemove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports